import enShortStrings from 'react-timeago/lib/language-strings/en-short';

export const enShort = {
	...enShortStrings,
	suffixAgo: 'ago',
};
